import { AxiosInstance } from 'axios';
import { JsonApiResource, JsonApiResponse } from 'types/store/jsonApi';
import { initAxios } from 'utils/axios';
import {
  RequestDrillDownApiResponse,
  ProjectDrillDownApiResponse,
  TaskDrillDownApiResponse,
  UserDrillDownApiResponse,
  CapacityManagementDrillDownApiResponse,
  EventDrillDownApiResponse,
} from './types';

type DrillDownAttributes =
  | RequestDrillDownApiResponse
  | ProjectDrillDownApiResponse
  | TaskDrillDownApiResponse
  | UserDrillDownApiResponse
  | CapacityManagementDrillDownApiResponse
  | EventDrillDownApiResponse;

export interface DrilldownJsonApiResponse
  extends JsonApiResponse<DrillDownAttributes> {
  data: JsonApiResource<DrillDownAttributes>[];
}

type DrilldownParams = Record<
  string,
  string | number | boolean | Array<string | number>
>;

class InsightDrilldownApi {
  private readonly axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = initAxios();
  }

  async getDrilldownData(
    url: string,
    params?: DrilldownParams
  ): Promise<DrilldownJsonApiResponse> {
    const { data } = await this.axiosInstance.get<DrilldownJsonApiResponse>(
      url,
      {
        params,
      }
    );

    return data;
  }
}

export default InsightDrilldownApi;
